import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fieldAlias',
})
export class FieldAliasPipe implements PipeTransform {
  transform(value: any, fieldOrFields: __esri.Field | __esri.Field[]) {
    if (fieldOrFields) {
      if (!Array.isArray(fieldOrFields)) {
        fieldOrFields = [fieldOrFields];
      }

      const field = fieldOrFields.find((x) => x.name === value);
      if (field?.alias) {
        value = field.alias;
      }
    }

    return value;
  }
}
